import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Layout, Menu, Select, Dropdown } from 'antd';
import Button from './common/atoms/DSButton';
import { DSIcon } from './common/atoms';
import { SideBar } from './common/molecules';
import HelpApi from '../services/help.api';
import handleAppError from './handlers/handleAppError';
import { utilizationApi } from '../services';
import { ContractsManager } from '../managers';
import NavBar from './NavBar';
import { AppStateContext } from '../utils/contexts';

const { Content } = Layout;
const SubMenu = Menu.SubMenu;
const Option = Select.Option;

window.axios = axios.create({
  headers: {
    common: {
      'X-EKINCARE-KEY': sessionStorage.getItem('axiosHeaders'),
      'X-COMPANY-ID': sessionStorage.getItem('company_id'),
    },
  },
});
class MainLayout extends Component {
  static contextType = AppStateContext;
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      redirect: false,
      role: sessionStorage.getItem('role'),
      drawerflag: false,
      initialKey: null,
      help_data: null,
      digitization: sessionStorage.getItem('digitization'),
      companyStatus: 'loading',
      companyError: '',
      benefitError: false,
      benefitList: [],
      isBenefitListLoaded: false,
      companyId: null,
      navigationOpen: false,
    };
    this.logout = this.logout.bind(this);
  }

  handleChange(value, key) {
    let cal_http_https = window.API_URL.search('https') === -1 ? 'http' : 'https';
    let api_url = window.API_URL;
    let cal_url = api_url.replace('/v1/', '');
    console.log(`selected ${value}`);
    window.axios.defaults.headers.common['X-COMPANY-ID'] = value;
    sessionStorage.setItem('company_id', value);
    sessionStorage.setItem('company_name', key.props.companyName);
    sessionStorage.setItem('is_child_company', JSON.stringify(key.props.isChildCompany));
    window.location = window.location;
    sessionStorage.setItem(
      'calendar_url',
      cal_url.replace(cal_http_https, 'webcal') + '/calendar/' + key.props.calendarToken + '/calendar.ics'
    );
  }

  handleBlur() {
    console.log('blur');
  }

  handleFocus() {
    console.log('focus');
  }

  getHelpData = async () => {
    await HelpApi.help_request(
      {},
      (res) => this.setState({ help_data: res.data }),
      (err) => handleAppError(err)
    );
  };

  getDigitizationFlag = async () => {
    const requestedCompany = sessionStorage.getItem('company_id');
    const revision = this.companyRequest = (this.companyRequest || 0) + 1;
    this.benefitRequest = (this.benefitRequest || 0) + 1;
    const isCurrent = () => !this.unmounted && revision === this.companyRequest && requestedCompany === sessionStorage.getItem('company_id');
    ['contract_id', 'digitization', 'isOPDAccount'].forEach(key => sessionStorage.removeItem(key));
    this.setState({ companyId: requestedCompany, companyStatus: 'loading', companyError: '', digitization: null, benefitList: [], isBenefitListLoaded: false, benefitError: false });
    return utilizationApi.fetchContracts(
      {},
      (res) => {
        if (!isCurrent()) return null;
        if (res.data && res.data.length > 0) {
          // Sorted through ContractsManager rather than read off `res.data[0]`. The endpoint has no ORDER
          // BY, so the first row is whichever one Postgres returned — for company 6175, whose periods
          // overlap, an expired one. Overview and OPD Overview seed their period from this `contract_id`,
          // so they opened on it tagged PREVIOUS, and these two flags came off the same wrong period.
          const [current] = new ContractsManager(res.data).data;
          let digitization = current.digitization;
          let isOPDAccount = Boolean(current.enable_spending_account || current.remote_wallet_enabled);
          sessionStorage.setItem('digitization', digitization);
          sessionStorage.setItem('contract_id', current.id);
          sessionStorage.setItem('isOPDAccount', isOPDAccount);
          this.setState({ digitization, companyStatus: 'ready' });
          this.fetchBenefitList(requestedCompany);
          return current;
        }
        this.setState({ companyStatus: 'error', companyError: 'No contracts available for this company.' });
        this.fetchBenefitList(requestedCompany);
        return null;
      },
      (err) => {
        if (!isCurrent()) return null;
        this.setState({ companyStatus: 'error', companyError: 'Could not load this company.' });
        this.fetchBenefitList(requestedCompany);
        handleAppError(err);
        return null;
      }
    );
  }
  componentDidMount() {
    let is_collapsed = sessionStorage.getItem('collapsed');
    is_collapsed === 'true' ? this.setState({ collapsed: true }) : this.setState({ collapsed: false });

    this.getHelpData();
    this.getDigitizationFlag();
    window.addEventListener('resize', this.closeNavigationOnDesktop);
  }

  componentWillUnmount() {
    this.unmounted = true;
    window.removeEventListener('resize', this.closeNavigationOnDesktop);
  }

  closeNavigationOnDesktop = () => {
    if (window.innerWidth >= 1024 && this.state.navigationOpen) this.setState({ navigationOpen: false });
  };

  toggleNavigation = event => {
    this.navigationTrigger = event.currentTarget;
    this.setState(state => ({ navigationOpen: !state.navigationOpen }));
  };
  closeNavigation = () => this.setState({ navigationOpen: false });
  restoreNavigationFocus = visible => {
    if (visible || this.state.navigationOpen || !this.navigationTrigger?.isConnected) return;
    const target = window.innerWidth < 1024 ? this.navigationTrigger : document.querySelector('nav[aria-label="Sidebar"] a');
    target?.focus();
  };

  componentDidUpdate(prevProps){
    if (this.state.navigationOpen && prevProps.location?.pathname !== this.props.location?.pathname) this.closeNavigation();
  }

  fetchBenefitList = (companyId) => {
    if (companyId) {
      const revision = this.benefitRequest = (this.benefitRequest || 0) + 1;
      const isCurrent = () => !this.unmounted && revision === this.benefitRequest && String(companyId) === sessionStorage.getItem('company_id');
      this.setState({ benefitList: [], isBenefitListLoaded: false, benefitError: false });
      return utilizationApi.fetchUtilizationBenefitList(
        { companyId: companyId },
        (response) => {
          if (!isCurrent()) return;
          this.setState({
            benefitList: response?.data?.benefits || [],
            isBenefitListLoaded: true,
          });
        },
        (error) => {
          if (!isCurrent()) return;
          this.setState({ benefitError: true });
          handleAppError(error);
        },
      );
    }
  };

  updateCollapse = () => {
    this.setState({ collapsed: false }, function () {
      sessionStorage.setItem('collapsed', false);
    });
  };

  toggleCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed }, function () {
      sessionStorage.setItem('collapsed', this.state.collapsed);
    });
  };

  toggle = () => {
    this.setState({ collapsed: !this.state.collapsed }, function () {
      sessionStorage.setItem('collapsed', this.state.collapsed);
    });
  };

  logout = () => {
    sessionStorage.removeItem('company_id');
    sessionStorage.clear();
    this.setState({ redirect: true });
  };

  handleTabChange = (e) => {
    sessionStorage.setItem('defaultSelectedTab', e.key);
  };

  showCompany() {
    if (this.state.role === 'Broker' || this.state.role === 'CSM' || this.state.role === 'CSMMaster') {
      return (
        <span style={{ paddingLeft: 12 }}>
          <Select
            showSearch
            style={{ width: 250, backgroundColor: '#fff' }}
            value={parseInt(sessionStorage.getItem('company_id'))}
            placeholder='Select a company'
            optionFilterProp='children'
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            
            {JSON.parse(sessionStorage.getItem('companies')).map((key) => {
              return (
                <Option value={key.id} companyName={key.name} isChildCompany={key.parent_company_id} calendarToken={key.calendar_token}>
                  {key.name}
                </Option>
              );
            })}
          </Select>
        </span>
      );
    }
  }

  showRightMenu() {
    return (
      <div style={{ float: 'right' }}>
        <Button
          type='primary'
          shape='circle'
          style={{ right: '5px', backgroundColor: '#2563EB', color: 'white' }}
          disabled='false'
        >
          {sessionStorage.getItem('hr_name')[0]}
        </Button>
        <Dropdown
          overlay={this.showMenu()}
          style={{
            color: '#2563EB',
            position: 'fixed',
            right: 0,
            paddingTop: 4,
          }}
        >
          <a className='ant-dropdown-link' href='#'>
            {sessionStorage.getItem('hr_name')} <DSIcon name='chevron-down' className='ml-1 inline-block text-gray-500' size={14} />
          </a>
        </Dropdown>
      </div>
    );
  }

  showMenu() {
    if (
      this.state.role !== 'regional_staff' &&
      this.state.role !== 'Broker' &&
      this.state.role !== 'PreEmp' &&
      this.state.role !== 'PreEmpRequest' &&
      this.state.role !== 'CSM' &&
      this.state.role !== 'CSMMaster'
    ) {
      return (
        <Menu>
          <Menu.Item key='2'>
            <span>{sessionStorage.getItem('hr_email')}</span>
          </Menu.Item>
          {/* <Menu.Item key='0'>
            <Link to='/account-managers'>
              <span>Help</span>
            </Link>
          </Menu.Item> */}
          <Menu.Item key='1' onClick={this.logout}>
            <a href='' onClick={this.logout}>
              Logout
            </a>
          </Menu.Item>
        </Menu>
      );
    } else {
      return (
        <Menu>
          <Menu.Item key='1'>
            <span>{sessionStorage.getItem('hr_email')}</span>
          </Menu.Item>
          <Menu.Item key='0' onClick={this.logout}>
            <a href='#' onClick={this.logout}>
              Logout
            </a>
          </Menu.Item>
        </Menu>
      );
    }
  }

  renderPreEmpMenu() {
    let show_pre_emp = sessionStorage.getItem('showPreEmp');
    if (show_pre_emp === 'true') {
      return (
        <Menu.Item key='8'>
          <Link to='/pre-employee-checkup'>
            <DSIcon name='user-plus' className='mr-2 inline-block text-gray-500' size={16} />
            <span>Pre Emp Checkup</span>
          </Link>
        </Menu.Item>
      );
    } else {
      return <div />;
    }
  }

  renderCalendar() {
    if (this.state.role !== 'regional_staff' && this.state.role !== 'Broker' && this.state.role !== 'PreEmp' && this.state.role !== 'PreEmpRequest') {
      return (
        <Menu.Item key='20'>
          <Link to='/wellness-calendar'>
            <DSIcon name='calendar' className='mr-2 inline-block text-gray-500' size={16} />
            <span>Wellness Calendar</span>
          </Link>
        </Menu.Item>
      );
    } else {
      return <div />;
    }
  }

  renderOverview() {
    if (this.state.role !== 'regional_staff' && this.state.role !== 'PreEmp' && this.state.role !== 'PreEmpRequest') {
      return (
        <Menu.Item key='9'>
          <Link to='/overview'>
            <DSIcon name='clock' className='mr-2 inline-block text-gray-500' size={16} />
            <span>Overview</span>
          </Link>
        </Menu.Item>
      );
    } else {
      return <div />;
    }
  }

  renderLaunchActivities() {
    if (
      this.state.role !== 'regional_staff' &&
      this.state.role !== 'Broker' &&
      this.state.role !== 'PreEmp' &&
      this.state.role !== 'PreEmpRequest' &&
      this.state.role !== 'CSM' &&
      this.state.role !== 'CSMMaster'
    ) {
      return (
        <SubMenu
          key='sub3'
          title={
            <span>
              <DSIcon name='rocket' className='mr-2 inline-block text-gray-500' size={16} />
              <span>Launch Activities</span>
            </span>
          }
        >
          <Menu.Item key='10'>
            <Link to='/pre-registration'>
              <DSIcon name='user-plus' className='mr-2 inline-block text-gray-500' size={16} />
              <span>Pre Registration</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      );
    } else {
      return <div />;
    }
  }

  renderServicers() {
    if (this.state.role !== 'regional_staff' && this.state.role !== 'Broker' && this.state.role !== 'PreEmp' && this.state.role !== 'PreEmpRequest') {
      return (
        <SubMenu
          key='sub6'
          title={
            <span>
              <DSIcon name='globe' className='mr-2 inline-block text-gray-500' size={16} />
              <span>Services</span>
            </span>
          }
        >
          <Menu.Item key='11'>
            <Link to='/customer-appointments'>
              <DSIcon name='clock' className='mr-2 inline-block text-gray-500' size={16} />
              <span>Appointments</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      );
    } else {
      return <div />;
    }
  }

  renderEngaments() {
    if (this.state.role !== 'regional_staff' && this.state.role !== 'Broker' && this.state.role !== 'PreEmp' && this.state.role !== 'PreEmpRequest') {
      return (
        <SubMenu
          key='sub5'
          title={
            <span>
              <DSIcon name='users' className='mr-2 inline-block text-gray-500' size={16} />
              <span>Engagement</span>
            </span>
          }
        >
          <Menu.Item key='12'>
            <Link to='/facilities'>
              <DSIcon name='list' className='mr-2 inline-block text-gray-500' size={16} />
              <span>Activities</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      );
    } else {
      return <div />;
    }
  }

  renderLogo() {
    if (this.state.collapsed) {
      return (
        <img
          src='https://res.cloudinary.com/ekincare/image/upload/v1541072851/hr_dashboard_login_page/logo_icon.svg'
          alt=''
        />
      );
    } else {
      return (
        <img
          src='https://res.cloudinary.com/ekincare/image/upload/v1541074570/hr_dashboard_login_page/ekincare-logo-new-white.svg'
          alt=''
        />
      );
    }
  }

  renderCSM() {
    if (this.state.role === 'CSMMaster') {
      return (
        <Menu.Item key='14'>
          <Link to='/account-managers'>
            <DSIcon name='user' className='mr-2 inline-block text-gray-500' size={16} />
            <span>CSM</span>
          </Link>
        </Menu.Item>
      );
    }
  }

  renderEmployeeData() {
    if (
      this.state.role !== 'regional_staff' &&
      this.state.role !== 'Broker' &&
      this.state.role !== 'PreEmp' &&
      this.state.role !== 'PreEmpRequest' &&
      this.state.role !== 'CSM' &&
      this.state.role !== 'CSMMaster'
    ) {
      return (
        <SubMenu
          key='sub6'
          title={
            <span>
              <DSIcon name='rocket' className='mr-2 inline-block text-gray-500' size={16} />
              <span>Employee Data</span>
            </span>
          }
        >
          <Menu.Item key='15' style={{ height: 'auto' }}>
            <Link to='/employee-registration'>
              <div style={{ lineHeight: 'normal', margin: '7% auto 7% auto' }}>
                <div>Employee</div>
                <div>Registration</div>
              </div>
            </Link>
          </Menu.Item>{' '}
          <Menu.Item key='16'>
            <Link to='/delete-employees'>
              <span>Delete Employees</span>
            </Link>
          </Menu.Item>
          <Menu.Item key='17'>
            <Link to='/update-employees'>
              <span>Update Employees</span>
            </Link>
          </Menu.Item>
          <Menu.Item key='18'>
            <Link to='/family-registration'>
              <span>Family Registration</span>
            </Link>
          </Menu.Item>
        </SubMenu>
      );
    } else {
      return <div />;
    }
  }

  toggleHelpDrawer = (initialKey) => {
    this.setState({ drawerflag: !this.state.drawerflag, initialKey: initialKey });
  };
  render() {
    const { benefitList, isBenefitListLoaded} = this.state;
    const responsiveNavigation = /^\/(?:mailer|welcome-mailer|benefit-adoption-mailers|mail-config)\/?$/.test(this.props.location?.pathname || '');
    // Only mailer routes read sessionStorage contract_id; other pages render without a contract, as on master.
    const mailerRoute = /^\/(?:mailer|welcome-mailer|benefit-adoption-mailers|mail-config)\/?$/.test(this.props.location?.pathname || '');
    return (
      <SideBar previousState={this.state} benefitList={benefitList} isBenefitListLoaded={isBenefitListLoaded}
        responsiveNavigation={responsiveNavigation} navigationOpen={this.state.navigationOpen} onNavigationClose={this.closeNavigation}
        onNavigationVisibilityChange={this.restoreNavigationFocus}
        onRetryBenefits={() => this.fetchBenefitList(this.state.companyId)}>
        <NavBar
          history={this.props.history}
          mailerRoute={mailerRoute}
          responsiveNavigation={responsiveNavigation}
          navigationOpen={this.state.navigationOpen}
          toggleNavigation={this.toggleNavigation}
          previousState={this.state}
          initialKey={this.state.initialKey}
          showhelp={this.state.drawerflag}
          toggleHelp={this.toggleHelpDrawer}
          getDigitizationFlag= {this.getDigitizationFlag}
          hasPendingEmployeeUpload={Boolean(this.context?.employee_data?.file || this.context?.employee_data?.tabledata || this.context?.employee_data?.csvData)}
        />
        <Content
          id='contentScreen'
          className='mt-16 bg-gray-200 px-4 py-6 sm:px-6 sm:py-8'
        >
          {this.state.companyStatus === 'loading' ? <p role="status">Loading company…</p> : this.state.companyStatus === 'error' && mailerRoute ? <div role="alert"><p>{this.state.companyError}</p><Button onClick={this.getDigitizationFlag}>Retry</Button></div> : React.createElement(this.props.child, {
            ...this.props,
            toggleHelp: this.toggleHelpDrawer,
          })}
        </Content>
      </SideBar>
    );

  }
}
export default MainLayout;
